import React from 'react';

import { Gallery, GalleryItem } from '@gogame/components';
import { useScreenState } from '@gogame/screens';

import { ChartDataProvider } from './Chart';
import TrackerChart from './TrackerChart';

const TrackerChartsSlider = ({ tooltipPosStrategy }) => {
  const screenState = useScreenState();
  return (
    <Gallery>
      {screenState.charts.map((_, index) => (
        <GalleryItem key={`tracker_${index}}`} withBorder={!!index}>
          <ChartDataProvider index={index}>
            <TrackerChart
              withPaper={false}
              tooltipPosStrategy={tooltipPosStrategy}
            />
          </ChartDataProvider>
        </GalleryItem>
      ))}
    </Gallery>
  );
};

export default TrackerChartsSlider;
